<template>
    <InformeCard title="Filtrar por sesión" style="height: 411px">
        <div class="col-12 mb-3" v-if="sesiones">
            <multiselect
                v-model="sesion"
                placeholder="Buscar sesiones"
                label="fecha"
                track-by="fecha"
                :options="sesiones"
                :multiple="false"
            ></multiselect>
        </div>
        <div class="col-12 mb-3" v-if="taquilleros">
            <multiselect
                :disabled="user.role === 11"
                v-model="taquillero"
                placeholder="Buscar taquilleros"
                label="email"
                track-by="id"
                :options="taquilleros"
                :multiple="false"
            ></multiselect>
        </div>
        <CardIcon
            :title="'TOTAL ENTRADAS:'"
            :data="total_general['entradas']"
            :icon="'fas fa-ticket-alt'"
        ></CardIcon>
        <CardIcon
            :title="'TOTAL RECAUDACIÓN (€):'"
            :data="total_general['recaudacion'] | formatear_precio"
            :icon="'far fa-money-bill-alt'"
        ></CardIcon>
    </InformeCard>
</template>

<script>
import InformeCard from "../InformeCard";
import CardIcon from '@/components/backend/components/CardIcon';

export default {
    props: ['event_id', 'informe', 'sesiones', 'taquilleros'],
    data() {
        return {
            sesion: null,
            taquillero: null
        }
    },
    watch: {
        sesion() {
            this.actualizar();
        },
        taquillero() {
            this.actualizar();
        },
        taquilleros() {
            if (this.user.role === 11) {
                this.taquillero = this.taquilleros.find(taquillero => taquillero.id === this.user.id);
            }
        }
    },
    created() {
        if (this.user.role === 11) {
            this.taquillero = this.taquilleros.find(taquillero => taquillero.id === this.user.id);
        }
    },
    computed: {
        total_general : function() {
            if(this.informe) {
                var totales = [];
                
                totales['entradas'] = 0;
                totales['recaudacion'] = 0;

                for(var i in this.informe) {
                    totales['entradas'] += this.informe[i].total;
                    totales['recaudacion'] += (this.informe[i].total * this.informe[i].price)
                }

                return totales;
            }

            return null;
        },
        user() {
            return this.$store.getters.getUser;
        }
    },
    methods: {
        actualizar() {
            var sesion = null;
            var taquillero = null;

            if(this.sesion) {
                sesion = this.sesion.id;
            }

            if(this.taquillero) {
                taquillero = this.taquillero.id;
            }

            this.$emit('actualizar', sesion, taquillero);
        }
    },
    components: {
        InformeCard, CardIcon
    }
}
</script>
